import React from "react";
import "./Navbar.css";

const Navbaruser = ({isActive}) => {


  return (
    <>
      <div className={isActive ? "nav navactive" : "nav"}>
    
       
        <div className="user-logo" >
           Users
        </div>
       
      </div>
    </>
  );
};

export default Navbaruser;
